import React from "react";
import Button from "../../../components/buttons";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { Modal } from "react-bootstrap";
import { FormSelect } from "../../../components/forms";
import { ModalConfirmationWithReturn } from "../../../types/DefModalOptions";
import { MasterAccountSalutationType } from "../../../types/MasterAccountSalutationTypes";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export type DeleteSalutationModalProps = ModalConfirmationWithReturn<MasterAccountSalutationType[], MasterAccountSalutationType | null> & {
    isDeletionTheDefault: boolean
};

const DeleteSalutationModal = ({ 
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    isDeletionTheDefault,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<DeleteSalutationModalProps>) => {
    const [selectedSalutation, setSelectedSalutation] = React.useState<MasterAccountSalutationType | null>(null);

    const onClose = () => cancel!();

    const onOkay = () => proceed!(selectedSalutation);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Delete Salutation?</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <p className="m-0">
                    Are you sure you would like to delete this Salutation?
                </p>
                {isDeletionTheDefault && defaultValues && defaultValues.length > 1 && (
                    <React.Fragment>
                        <p className="my-3">The record you are trying to delete is also assigned as the default salutation for the account. Please select a new default, or leave empty to assign the master account salutation as the new default.</p>
                        <FormSelect 
                            options={defaultValues.map((el) => { 
                                return { value: el.salutationId, label: el.addressee }
                            })}
                            placeholder="Default Salutation"
                            defaultValue={selectedSalutation}
                            onChange={(values) => setSelectedSalutation(values.value)}
                        />
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={isDeletionTheDefault && !selectedSalutation} onClick={onOkay}>Delete</Button>
                <Button variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export function openDeleteSalutationModal(isDeletionTheDefault: boolean, extraSaluations: MasterAccountSalutationType[]) {
    return createConfirmation<DeleteSalutationModalProps, MasterAccountSalutationType | null>(confirmable(DeleteSalutationModal))({
        dialogId: "delete_salutation_modal",
        defaultValues: extraSaluations,
        isDeletionTheDefault
    });
}